<template>
  <v-snackbar
    v-model="snackbar.visible"
    app
    top
    :color="snackbar.color"
    :right="!isMobile()"
    :timeout="timeout"
    @input="setSnackbarVisible($event)"
  >
    {{ snackbar.text }}

    <template v-slot:action="{ attrs }">
      <v-btn
          v-show="snackbar.buttonText"
          v-bind="attrs"
          text
          @click="handleClick"
      >
        {{ snackbar.buttonText }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

import isMobile from '@/mixins/displayAdaptable';
import hasAppSnackbar from '@/mixins/hasAppSnackbar';
import constants from '@/constants';

export default {
  name: 'AppSnackbar',
  mixins: [isMobile, hasAppSnackbar],

  data() {
    return {
      defaultTimeout: 5000,
    };
  },

  computed: {
    ...mapState(['snackbar']),

    timeout() {
      return this.snackbar.buttonText === this.$t('misc.undo')
        ? constants.CLOCK_OUT_DELAY_IN_MILLISECONDS
        : this.defaultTimeout;
    },
  },

  methods: {
    ...mapMutations(['setSnackbarVisible']),

    handleClick() {
      this.snackbar.buttonHandler();
      this.setSnackbarVisible(false);
    },
  },
};
</script>
